var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 flex"},[_c('div',{staticClass:"flex-1 text-left"},[_vm._t("default")],2),_c('div',_vm._l((_vm.languages),function(item){return _c('button',{key:item.title,on:{"click":function($event){return _vm.changeLocale(item.language)}}},[_c('country-flag',{attrs:{"country":item.flag,"size":"small"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }